import { endpoints } from "config";
import { NCRCategoryRow } from "./NCRCategoryList.types";
import { CellOptions } from "components/newFlexTable/Cell";

export const NCR_CATEGORY_LIST_COLUMNS = {
  Id: "ncrCategoryTypes__Id" as const,
  Name: "ncrCategoryTypes__CategoryName" as const,
  Active: "NcrCategoryTypes__bActive" as const,
};

export const NCR_CATEGORY_LIST_ENDPOINTS = {
  delete: endpoints.ncrCategory.delete,
  list: endpoints.ncrCategory.list,
};

export const rowCellOptions: Record<keyof NCRCategoryRow, CellOptions> = {
  ncrCategoryTypes__Id: { width: "Small" },
  ncrCategoryTypes__CategoryName: { width: "Large" },
  ncrCategoryTypes__bActive: { width: "Small" },
  ncrCategoryTypes__AddDate: { width: "Medium2" },
  ncrCategoryTypes__AddedBy: { width: "Medium2" },
  ncrCategoryTypes__EditDate: { width: "Medium2" },
  ncrCategoryTypes__LastEditedBy: { width: "SemiLarge2" },
};
